import { Text } from "@certn/cascadia";
import { CascadiaJsonFormContext } from "@certn/forms/src/CascadiaJsonFormContext";
import get from "lodash.get";
import { useContext, useMemo } from "react";
import { ItemProps } from "../types";
import { getTextColor } from "./utils";
import { matchesCondition } from "../../utils";

function interpolateTemplate(
  template: string,
  variables: Record<string, string | number>
): string {
  return template.replace(/\{\{(\w+)\}\}/g, (match, key) => {
    const value = variables[key];
    return value !== undefined ? String(value) : match;
  });
}

export function CountSubtitle(props: ItemProps) {
  const { values } = useContext(CascadiaJsonFormContext);
  const {
    uischema: { options },
  } = props;

  const item = useMemo(() => get(values, props.path), [values, props.path]);
  const array = useMemo<any[] | undefined>(
    () =>
      options?.subtitle.listFieldPath
        ? get(item, options?.subtitle.listFieldPath)
        : item,
    [item, options?.subtitle.listFieldPath]
  );
  const itemCount = useMemo(
    () =>
      array
        ?.filter((item) =>
          matchesCondition(item, options?.subtitle.itemCondition)
        )
        .length.toString(),
    [array, options?.subtitle.itemCondition]
  );
  const textColor = useMemo(
    () => getTextColor(item, options?.subtitle),
    [item, options?.subtitle]
  );

  const labelText = interpolateTemplate(options?.subtitle.labelTemplate || "", {
    total: array?.length.toString() || "0",
    itemCount: itemCount || "0",
  });

  return <Text color={textColor}>{labelText}</Text>;
}
